export default __webpack_public_path__ + "static/media/stars.ba3e6c7d.svg";